import gsap from 'gsap';

export function initMenu(ctx) {
  const { menuToggle, menuPanel, menuClose, menuLinks, menuProductLinks, menuPanelImage, header } = ctx;

  if (!menuToggle || !menuPanel) {
    return ctx;
  }

  const content = menuPanel.querySelector('.menu-panel__content');

  const timeline = gsap
    .timeline({ paused: true })
    .set(menuPanel, { autoAlpha: 0, yPercent: 40 })
    .to(menuPanel, {
      autoAlpha: 1,
      yPercent: 0,
      duration: 0.6,
      ease: 'power3.out',
    });

  if (content) {
    timeline.from(
      content,
      {
        y: -40,
        opacity: 0,
        duration: 0.8,
        ease: 'power3.out',
      },
      '<'
    );
  }

  timeline.from(
    menuLinks,
    {
      y: 30,
      opacity: 0,
      stagger: 0.05,
      duration: 0.4,
      ease: 'power3.out',
    },
    '-=0.4'
  );

  ctx.menuTimeline = timeline;

  const activateProductLink = (link) => {
    if (!link || !menuProductLinks.length) {
      return;
    }

    menuProductLinks.forEach((item) => item.classList.remove('is-active'));
    link.classList.add('is-active');

    const image = link.dataset.productImage;
    if (menuPanelImage) {
      if (image) {
        menuPanelImage.style.backgroundImage = `url('${image}')`;
      } else {
        const defaultImage = menuPanelImage.dataset.defaultImage;
        if (defaultImage) {
          menuPanelImage.style.backgroundImage = `url('${defaultImage}')`;
        }
      }
    }
  };

  const bindProductLinkEvents = () => {
    if (!menuProductLinks.length) {
      return;
    }

    menuProductLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => activateProductLink(link));
      link.addEventListener('focus', () => activateProductLink(link));
    });
  };

  const toggleMenu = () => {
    if (!menuToggle || !menuPanel) {
      return;
    }

    const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
    const willOpen = !isOpen;

    menuToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    menuPanel.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
    menuToggle.classList.toggle('is-open', willOpen);
    menuPanel.classList.toggle('is-open', willOpen);

    const isMobileMenu = window.innerWidth <= 800;

    if (willOpen) {
      ctx.menuTimeline?.play();
      activateProductLink(menuProductLinks[0]);
      if (isMobileMenu) {
        header?.classList.add('is-menu-open');
      }
    } else {
      ctx.menuTimeline?.reverse();
      if (isMobileMenu) {
        header?.classList.remove('is-menu-open');
      }
    }
  };

  const closeMenu = () => {
    if (menuToggle.getAttribute('aria-expanded') === 'true') {
      toggleMenu();
    }
  };

  bindProductLinkEvents();
  activateProductLink(menuProductLinks[0]);

  menuToggle.addEventListener('click', toggleMenu);
  menuClose?.addEventListener('click', closeMenu);
  menuPanel.addEventListener('click', (event) => {
    if (event.target === menuPanel) {
      closeMenu();
    }
  });

  return ctx;
}
